/*
    P&L chart module
*/
import cloneDeep from 'lodash/cloneDeep';
import pnlChartConfigBuilder from './pnl-chart-config-builder';
import d3Utils from '../../../utils/d3Utils';
import { tableTooltip } from '../widget-utilities/widget-tooltip';
import chartUtils from '../../../utils/chart-utils';

var pnlChart = function pnlChart() {

    // Render P&L chart widget
    var renderWidget = function renderWidget(widgetConfig) {
        var ContainerId = widgetConfig.ContainerId,
            Height = widgetConfig.Height,
            Model = widgetConfig.Model,
            Cloud = widgetConfig.Cloud,
            Data = widgetConfig.Data,
            PnLConfig = widgetConfig.PnLConfig;


        var parentContainerId = ContainerId.includes('flip-') ? ContainerId.split('flip-')[1] : ContainerId;

        var el = window.document.querySelector('#' + ContainerId);

        d3.select(el).select('svg').remove();

        var modelName = Model;
        var cloudName = Cloud;
        var crumbFormat = {
            CloudName: cloudName,
            ModelName: modelName,
            Type: "Node",
            Name: "",
            FieldName: "",
            Value: ""
        };
        var stackOnFieldName = PnLConfig.StackOnField;
        var totalName = PnLConfig.TotalName;
        var config = JSON.parse(chartUtils.replaceAll(JSON.stringify(PnLConfig), '\x01', ""));
        var valueFields = JSON.parse(chartUtils.replaceAll(JSON.stringify(PnLConfig.ValueFields), '\x01', ""));
        var stackOnFields = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.stackOnFields), '\x01', ""));
        var data = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.seriesData), '\x01', ""));
        var totalData = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.Total), '\x01', ""));
        var uniqueRootValues = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.rootValues), '\x01', ""));
        var inverseStackHeaders = false;
        var levelCount = 0;
        if (config.ChildConfigs != null) levelCount = config.ChildConfigs.length;

        var pnlContainer = window.document.createElement('div');
        pnlContainer.setAttribute("style", "width:100%;height:92%;overflow:auto;");
        var className = "visor-table-container";
        pnlContainer.setAttribute("class", className);
        el.appendChild(pnlContainer);

        var pnlTable = window.document.createElement('table');
        pnlTable.setAttribute("class", "pnl-fixTable visor-table");
        pnlTable.setAttribute("cellpadding", "0");
        pnlTable.setAttribute("cellspacing", "0");
        if (PnLConfig.IsFreeze) pnlTable.setAttribute("style", "border-collapse: separate;");
        pnlContainer.appendChild(pnlTable);

        var pnlHeaderContainer = window.document.createElement('thead');
        pnlHeaderContainer.setAttribute("style", "position: sticky; top: 0;");
        pnlTable.appendChild(pnlHeaderContainer);
        addHeaders();

        // Animate PnL widget
        animatePnlWidget(parentContainerId, Height);

        // Subscribe to PnL events
        subscribePnlEvents();

        function subscribePnlEvents() {
            $(document).off("click", ".toggle-childs").on("click", ".toggle-childs", function (e) {
                var keyField = $(this).parents('tr').attr("keyField");
                var parentName = $(this).parents('tr').attr("parentname");
                var showHide = $(this).parents('tr');

                var level = $(this).parents('tr').attr("level");
                var levelCount = $(this).parents('tr').attr("levelCount");

                if (parentName == null || parentName == "") parentName = "";else parentName = parentName + "-";

                var searchKey = parentName + keyField;

                if ($(this).hasClass("fa-plus-square")) {
                    var _childs = $(this).parents('table').find('.collapsable[parentName="' + searchKey + '"]');
                    _childs.show("slow");
                    _childs.find('td.pnl-keyField i').removeClass("fa-minus-square").removeClass("fa-plus-square").addClass("fa-plus-square");
                    $(this).removeClass("fa-plus-square").addClass("fa-minus-square");
                } else {
                    var _childs2 = $(this).parents('table').find('.collapsable[parentName*="' + searchKey + '"]');;
                    _childs2.hide("slow");
                    $(this).removeClass("fa-minus-square").addClass("fa-plus-square");
                }
            });

            $(document).off("click touchstart", ".expand-trigger").on("click touchstart", ".expand-trigger", function (e) {
                var expandLevel = Number($(this).attr("currentLevel")) + 1;
                var table = $(this).parents(".widget-container").find(".pnl-fixTable");
                var parent = $(table).find("tr[level = '" + (+expandLevel - 2) + "']").find('td.pnl-keyField i.fa-plus-square');
                for (var _index = 0; _index < expandLevel; _index++) {
                    var _parent = $(table).find("tr[level = '" + _index + "']").find('td.pnl-keyField i.fa-plus-square');
                    if (_parent.length > 0) {
                        expandLevel = _index + 1;
                        break;
                    }
                }

                $(table).find("tr[level = '" + expandLevel + "']").show();
                $(this).attr("currentLevel", expandLevel.toString());
                $(this).parent().find(".collapse-trigger").attr("currentLevel", expandLevel.toString());
                $(table).find("tr[level = '" + (+expandLevel - 1) + "']").find('td.pnl-keyField i').removeClass("fa-plus-square").addClass("fa-minus-square");
                e.stopPropagation();
            });

            $(document).off("click touchstart", ".collapse-trigger").on("click touchstart", ".collapse-trigger", function (e) {
                var collapseLevel = $(this).attr("currentLevel");
                var table = $(this).parents(".widget-container").find(".pnl-fixTable");
                for (var _index2 = collapseLevel; _index2 >= 0; _index2--) {
                    var parent = $(table).find("tr[level = '" + _index2 + "']").find('td.pnl-keyField i.fa-minus-square');
                    if (parent.length > 0) {
                        collapseLevel = Number(_index2 + 1);
                        break;
                    }
                }

                if (collapseLevel != 0) {
                    $(table).find("tr[level = '" + (+collapseLevel - 1) + "']").find('td.pnl-keyField i').removeClass("fa-minus-square").addClass("fa-plus-square");
                    $(table).find("tr[level = '" + collapseLevel + "']").hide();
                    $(this).attr("currentLevel", (collapseLevel - 1).toString());
                    $(this).parent().find(".expand-trigger").attr("currentLevel", (collapseLevel - 1).toString());
                }

                e.stopPropagation();
            });
        }

        // Add animation to PnL widget
        function animatePnlWidget(parentContainerId, height) {
            var pnlTable = $("#" + parentContainerId).find("table");

            if (pnlTable.floatThead) {
                pnlTable.parent().height(height);
                $(pnlTable.parents(".widget-container")).css("border", "none");

                pnlTable.floatThead({
                    scrollContainer: function scrollContainer($table) {
                        return $table.parent();
                    }
                });
            }
        }

        function addValueFieldHeaders(valueHeaderRow) {
            for (var valueIndex = 0; valueIndex < valueFields.length; valueIndex++) {
                var item = valueFields[valueIndex];
                var headerName = item.HeaderName;

                var header = window.document.createElement('th');
                valueHeaderRow.appendChild(header);
                header.innerHTML = headerName;
                if (stackOnFields != null) {
                    header.setAttribute("colspan", stackOnFields.length);
                }
                if (item.ShowTotal) addTotalColumnHeader(valueHeaderRow, item);
            }
        }

        function addHeaders() {
            var valueHeaderRow = window.document.createElement('tr');
            var stackHeaderRow = null;
            addCategoryHeader(valueHeaderRow);
            if (stackOnFields != null) stackHeaderRow = window.document.createElement('tr');
            addValueFieldHeaders(valueHeaderRow);
            if (inverseStackHeaders) {
                if (stackOnFields != null) {
                    addStackOnFieldHeaders(stackHeaderRow, valueHeaderRow);
                    pnlHeaderContainer.appendChild(stackHeaderRow);
                }
            } else {
                pnlHeaderContainer.appendChild(valueHeaderRow);
                if (stackOnFields != null) {
                    addStackOnFieldHeaders(stackHeaderRow, null);
                    pnlHeaderContainer.appendChild(stackHeaderRow);
                }
            }
        }

        function addStackOnFieldHeaders(stackHeaderRow) {
            for (var valueFieldIndex = 0; valueFieldIndex < valueFields.length; valueFieldIndex++) {
                for (var stackIndex = 0; stackIndex < stackOnFields.length; stackIndex++) {
                    var stackOnValue = stackOnFields[stackIndex];
                    var header = window.document.createElement('th');
                    stackHeaderRow.appendChild(header);
                    header.setAttribute("class", "top-fixed pnl-stack-header");
                    header.innerHTML = stackOnValue;
                }
            }
        }

        function addCategoryHeader(headerRow) {
            var header = window.document.createElement('th');
            header.setAttribute("class", "top-fixed left-fixed category-header");
            header.setAttribute("value", encodeURIComponent(JSON.stringify(config)));
            if (PnLConfig.IsFreeze) header.setAttribute("style", "position: sticky; left:0; border-collapse: separate; z-index:2;");

            var categoryTitle = config.CategoryTitle;
            if (categoryTitle == null) categoryTitle = "";
            header.innerHTML = categoryTitle;
            if (stackOnFields != null) header.setAttribute("rowspan", "2");

            var expandIcon = "<i class='fa fa-plus-square'></i>";
            var collapseIcon = "<i class='fa fa-minus-square'></i>";
            var expandButton = window.document.createElement('button');
            expandButton.setAttribute("id", "expand-one-level-PnL");
            expandButton.setAttribute("class", "expand-trigger");
            expandButton.setAttribute("currentLevel", "0");
            expandButton.setAttribute("title", "Expand one level");
            expandButton.innerHTML = expandIcon;

            var collapseButton = window.document.createElement('button');
            collapseButton.setAttribute("id", "collapse-one-level-PnL");
            collapseButton.setAttribute("class", "collapse-trigger");
            collapseButton.setAttribute("currentLevel", "0");
            collapseButton.setAttribute("title", "Collapse one level");
            collapseButton.innerHTML = collapseIcon;

            header.appendChild(expandButton);
            header.appendChild(collapseButton);
            headerRow.appendChild(header);
        }

        function addTotalColumnHeader(headerRow, valueField) {
            var headerName = valueField.TotalColumnName;
            var header = window.document.createElement('th');
            header.innerHTML = headerName;
            headerRow.appendChild(header);
        }

        var keyCombinations = [];
        var addedKeys = [];

        //sort the values in root node if it's a temporal column
        if (PnLConfig.RootConfig.KeyField && isTemporalField(PnLConfig.RootConfig.KeyField)) {
            var inverseSort = config.SortOrders[PnLConfig.RootConfig.KeyField] == chartUtils.sortType.descending;
            chartUtils.sort(uniqueRootValues, PnLConfig.RootConfig.KeyField, null, inverseSort, true);
        }

        for (var index = 0; index < uniqueRootValues.length; index++) {
            var rootValue = uniqueRootValues[index];
            keyCombinations.push(rootValue);
            addedKeys.push(rootValue);
            var rootValueData = JSON.parse(data[rootValue]);
            var childs = null;
            var childName = rootValueData["childName"];
            if (childName != null) childs = JSON.parse(rootValueData["childs"]);
            var sort = isTemporalField(childName);
            if (childs != null) addChildKeyCombinations(sort, childName, childs, rootValueData["FieldName"]);
        }

        function addChildKeyCombinations(sort, fieldName, childs, parentName) {
            if (sort) {
                var inverseSort = config.SortOrders[fieldName] == chartUtils.sortType.descending;
                chartUtils.sort(childs, fieldName, null, inverseSort, true);
            }
            for (var childIndex = 0; childIndex < childs.length; childIndex++) {
                var childValue = childs[childIndex];
                var searchKey = parentName + "-" + childValue;
                if (addedKeys.indexOf(searchKey) > 0) continue;
                keyCombinations.push(searchKey);
                addedKeys.push(searchKey);
                var levelData = JSON.parse(data[searchKey]);
                var levelChilds = null;
                var childName = levelData["childName"];
                if (childName != null) levelChilds = JSON.parse(levelData["childs"]);
                var sort = isTemporalField(childName);
                if (levelChilds != null) addChildKeyCombinations(sort, childName, levelChilds, searchKey);
            }
        }

        var seriesKeys = keyCombinations;
        var tbody = window.document.createElement('tbody');
        pnlTable.appendChild(tbody);
        for (var index = 0; index < seriesKeys.length; index++) {
            var key = seriesKeys[index];
            var seriesData = JSON.parse(data[key]);
            var levelData = JSON.parse(seriesData["data"]);
            var levelNumber = Number(seriesData["level"]);
            var fieldName = seriesData["FieldName"];
            var parentName = seriesData["parentName"];
            var crumb = getCrumbFormat(levelNumber, levelData[0]);
            var tr = window.document.createElement("tr");
            var rowClassname = "";
            var keyFieldCell = window.document.createElement('td');
            var cellClassName = "dataviz pnl-keyField left-fixed";
            var padding = levelNumber * 30 + "px";
            if (levelNumber == 0) {
                padding = "10px";
            }
            var paddingStyle = "padding-left:" + padding;
            var summaryIcon = "<i class='fa fa-plus-square toggle-childs parent'></i>";

            if (levelNumber < levelCount) {
                if (seriesData["childName"] != null) keyFieldCell.innerHTML = summaryIcon;
                rowClassname += "pnl-parent-row";
            }

            if (levelNumber > 0) {
                rowClassname += " collapsable";
                tr.setAttribute("parentname", parentName);
                tr.setAttribute("style", "display:none");
            }
            if (levelNumber == 0) rowClassname += " pnl-root-node";

            var fieldnameTag = '<span style=\'text-decoration: underline; color: #0000EE;\'>' + fieldName + '</span>';
            keyFieldCell.innerHTML += fieldnameTag;
            keyFieldCell.setAttribute("class", cellClassName);
            keyFieldCell.setAttribute("style", paddingStyle);
            if (crumb != null) keyFieldCell.setAttribute("coord", crumb);
            keyFieldCell.setAttribute("coord", crumb);
            if (PnLConfig.IsFreeze) keyFieldCell.setAttribute("style", 'position: sticky; left:0; background-color: white; ' + paddingStyle + ';');

            tr.appendChild(keyFieldCell);
            tr.setAttribute("class", rowClassname);
            tr.setAttribute("keyField", fieldName);
            tr.setAttribute("level", levelNumber);
            populateValueFields(levelData, tr, levelNumber);
            tbody.appendChild(tr);
        }

        if (totalName != null && totalName.toString().trim().length > 0) {
            var totalRow = window.document.createElement('tr');
            totalRow.setAttribute("class", "pnl-total-row");
            var keyFieldCell = window.document.createElement('td');
            keyFieldCell.setAttribute("class", "pnl-keyField");
            keyFieldCell.innerHTML = totalName;

            totalRow.appendChild(keyFieldCell);
            populateValueFields(totalData, totalRow, -1);
            tbody.appendChild(totalRow);
        }

        function populateValueFields(data, tr, levelNumber) {
            for (var v = 0; v < valueFields.length; v++) {
                var valueField = valueFields[v];
                var valueFieldName = valueField.ValueField;
                var valueFieldData = data[0][valueFieldName];
                if (stackOnFields != null) {
                    populateStackFields(valueField, data, tr, levelNumber);
                } else {
                    var td = window.document.createElement('td');
                    td.setAttribute("class", "pnl-value-field");
                    var value = valueFieldData;
                    var displayFormat = valueField.ValueFormat;
                    var currencySymbol = valueField.CurrencySymbol;
                    var baseFormat = valueField.BaseFormat;
                    var levelConfig = null;
                    if (levelNumber == 0) levelConfig = config.RootConfig;else levelConfig = getLevelConfig(levelNumber);

                    if (value == null) value = "-";
                    if (currencySymbol != null) td.innerHTML = '<span class="pnl-currencySymbol">' + currencySymbol + '</span>';

                    if (Number(value) < 0) {
                        value = chartUtils.format(value, displayFormat, null, null, baseFormat);
                        td.setAttribute("class", "pnl-value-field pnl-negative");
                    }

                    if (levelConfig != null && levelConfig.ConditionalFormatting != null && levelConfig.ConditionalFormatting.length > 0) applyConditionalFormatting(levelConfig, tr, td, value, data[0]);

                    var tooltipText = '';
                    var tooltip = valueField.Tooltip;
                    if (tooltip != null && tooltip.TooltipConfigs.length > 0 && data != null) {
                        tooltipText = tooltip.TooltipText;
                        for (var tipIndex = 0; tipIndex < tooltip.TooltipConfigs.length; tipIndex++) {
                            var tipItem = tooltip.TooltipConfigs[tipIndex];
                            var tipValue = data[tipItem.Id];
                            if (tipValue == null || tipValue == "--") {
                                var field = valueFields.find(function (element) {
                                    return element.ValueField == tipItem.TipField;
                                });
                                if (field != null) tipValue = data[valueField.ValueField];
                            }
                            if (tipValue != null && tipValue.toString().trim().length > 0) tipValue = chartUtils.format(tipValue, tipItem.ValueFormat, tipItem.CurrencySymbol, null, tipItem.BaseFormat, false);
                            if (tipValue == null || tipValue.trim().length == 0) tipValue = "--";
                            tooltipText = tooltipText.replace("{" + tipItem.TipField + "}", tipValue + " ");
                        }
                    } else if (tooltip != null && tooltip.TooltipConfigs.length == 0 && valueFieldData != null) tooltipText = tooltip.TooltipText;

                    if (tooltipText != "") td.setAttribute("label", tooltipText);
                    td.addEventListener("touchstart", function (e) {
                        tableTooltip.onMouseOver.call(this, e);
                    });
                    td.addEventListener("mouseover", function (e) {
                        tableTooltip.onMouseOver.call(this, e);
                    });
                    td.addEventListener("mouseout", function () {
                        tableTooltip.onMouseOut();
                    });
                    td.addEventListener("touchmove", function () {
                        tableTooltip.onTouchMove();
                    });
                    td.addEventListener("mousemove", function (e) {
                        tableTooltip.onMouseMove.call(this, e);
                    });
                    td.innerHTML += chartUtils.format(value, displayFormat, null, null, baseFormat);
                    tr.appendChild(td);
                }
                if (valueField.ShowTotal) populateValueTotalField(data, tr, levelNumber, valueField);
            }
        }

        function populateStackFields(valueField, data, tr, level) {
            for (var f = 0; f < stackOnFields.length; f++) {
                var name = stackOnFields[f];
                var stackData = findStackOnData(name, stackOnFieldName, data);

                var td = window.document.createElement('td');
                td.setAttribute("class", "pnl-value-field");

                var displayFormat = valueField.ValueFormat;
                var currencySymbol = valueField.CurrencySymbol;
                var baseFormat = valueField.BaseFormat;
                var levelConfig = null;
                if (levelNumber == 0) levelConfig = config.RootConfig;else levelConfig = getLevelConfig(levelNumber);

                var value = "";
                if (stackData != null) value = Number(stackData[valueField.ValueField]);

                if (value == null) value = "-";

                if (currencySymbol != null) td.innerHTML = '<span class="pnl-currencySymbol">' + currencySymbol + '</span>';

                if (Number(value) < 0) {
                    value = chartUtils.format(value, displayFormat, null, null, baseFormat);
                    td.setAttribute("class", "pnl-value-field pnl-negative");
                }
                td.innerHTML += chartUtils.format(value, displayFormat, null, null, baseFormat);

                if (levelConfig != null && levelConfig.ConditionalFormatting != null && levelConfig.ConditionalFormatting.length > 0) applyConditionalFormatting(levelConfig, tr, td, value, stackData);

                var tooltipText = '';
                var tooltip = valueField.Tooltip;
                if (tooltip != null && tooltip.TooltipConfigs.length > 0 && stackData != null) {
                    tooltipText = tooltip.TooltipText;
                    for (var tipIndex = 0; tipIndex < tooltip.TooltipConfigs.length; tipIndex++) {
                        var tipItem = tooltip.TooltipConfigs[tipIndex];
                        var tipValue = stackData[tipItem.Id];
                        if (tipValue == null || tipValue == "--") {
                            var field = valueFields.find(function (element) {
                                return element.ValueField == tipItem.TipField;
                            });
                            if (field != null) tipValue = stackData[valueField.ValueField];
                        }
                        if (tipValue != null && tipValue.toString().trim().length > 0) tipValue = chartUtils.format(tipValue, tipItem.ValueFormat, tipItem.CurrencySymbol, null, tipItem.BaseFormat, false);
                        if (tipValue == null || tipValue.trim().length == 0) tipValue = "--";
                        tooltipText = tooltipText.replace("{" + tipItem.TipField + "}", tipValue + " ");
                    }
                } else if (tooltip != null && tooltip.TooltipConfigs.length == 0 && stackData != null) tooltipText = tooltip.TooltipText;

                if (tooltipText != "") td.setAttribute("label", tooltipText);
                td.addEventListener("touchstart", function (e) {
                    tableTooltip.onMouseOver.call(this, e);
                });
                td.addEventListener("mouseover", function (e) {
                    tableTooltip.onMouseOver.call(this, e);
                });
                td.addEventListener("mouseout", function () {
                    tableTooltip.onMouseOut();
                });
                td.addEventListener("touchmove", function () {
                    tableTooltip.onTouchMove();
                });
                td.addEventListener("mousemove", function (e) {
                    tableTooltip.onMouseMove.call(this, e);
                });
                tr.appendChild(td);
            }
        }

        function populateValueTotalField(data, tr, levelNumber, valueField) {
            var td = window.document.createElement('td');
            td.setAttribute("class", "pnl-value-field");
            var valueFieldData = data[0][valueField.TotalColumnName];
            var value = valueFieldData;
            var displayFormat = valueField.ValueFormat;
            var currencySymbol = valueField.CurrencySymbol;
            var baseFormat = valueField.BaseFormat;
            var levelConfig = null;
            if (levelNumber == 0) levelConfig = config.RootConfig;else levelConfig = getLevelConfig(levelNumber);

            if (value == null) value = "-";
            if (currencySymbol != null) td.innerHTML = '<span class="pnl-currencySymbol">' + currencySymbol + '</span>';

            if (Number(value) < 0) {
                value = chartUtils.format(value, displayFormat, null, null, baseFormat);
                td.setAttribute("class", "pnl-value-field pnl-negative");
            }

            if (levelConfig != null && levelConfig.ConditionalFormatting != null && levelConfig.ConditionalFormatting.length > 0) applyConditionalFormatting(levelConfig, tr, td, value, data[0]);

            var tooltipText = '';
            var tooltip = valueField.Tooltip;
            if (tooltip != null && tooltip.TooltipConfigs.length > 0 && data != null) {
                tooltipText = tooltip.TooltipText;
                for (var tipIndex = 0; tipIndex < tooltip.TooltipConfigs.length; tipIndex++) {
                    var tipItem = tooltip.TooltipConfigs[tipIndex];
                    var tipValue = data[tipItem.Id];
                    if (tipValue == null || tipValue == "--") {
                        var field = valueFields.find(function (element) {
                            return element.ValueField == tipItem.TipField;
                        });
                        if (field != null) tipValue = data[valueField.ValueField];
                    }
                    if (tipValue != null && tipValue.toString().trim().length > 0) tipValue = chartUtils.format(tipValue, tipItem.ValueFormat, tipItem.CurrencySymbol, null, tipItem.BaseFormat, false);
                    if (tipValue == null || tipValue.trim().length == 0) tipValue = "--";
                    tooltipText = tooltipText.replace("{" + tipItem.TipField + "}", tipValue + " ");
                }
            } else if (tooltip != null && tooltip.TooltipConfigs.length == 0 && valueFieldData != null) tooltipText = tooltip.TooltipText;

            if (tooltipText != "") td.setAttribute("label", tooltipText);
            td.addEventListener("touchstart", function (e) {
                tableTooltip.onMouseOver.call(this, e);
            });
            td.addEventListener("mouseover", function (e) {
                tableTooltip.onMouseOver.call(this, e);
            });
            td.addEventListener("mouseout", function () {
                tableTooltip.onMouseOut();
            });
            td.addEventListener("touchmove", function () {
                tableTooltip.onTouchMove();
            });
            td.addEventListener("mousemove", function (e) {
                tableTooltip.onMouseMove.call(this, e);
            });
            td.innerHTML += chartUtils.format(value, displayFormat, null, null, baseFormat);
            tr.appendChild(td);
        }

        function findStackOnData(stackOnValue, stackOnFieldName, data) {
            for (var i = 0; i < data.length; i++) {
                if (stackOnValue == data[i][stackOnFieldName]) return data[i];
            }
        }

        function getCrumbFormat(level, d) {
            var c = null;
            if (level == 0) c = config.RootConfig;
            if (level > 0) {
                c = getLevelConfig(level);
            }
            if (c != null && c.CrumbMetaName != null && c.CrumbFieldName != null) {
                var crumb = crumbFormat;
                crumb.Name = c.CrumbMetaName;
                crumb.FieldName = c.CrumbFieldName;
                crumb.Value = d[c.CrumbFieldName];
                crumb.DisplayFieldName = c.CrumbDisplayFieldName;
                crumb.DisplayValue = d[c.CrumbDisplayFieldName];
                crumb.DefaultPerspective = c.DefaultPerspective;
                return JSON.stringify(crumb);
            }
        }

        function getLevelConfig(level) {
            var levelConfig = null;
            if (config.ChildConfigs != null) {
                for (var c = 0; c < config.ChildConfigs.length; c++) {
                    var childConfig = config.ChildConfigs[c];
                    if (childConfig.Level == level) {
                        levelConfig = childConfig;
                        break;
                    }
                }
            }
            return levelConfig;
        }

        function applyConditionalFormatting(field, tr, td, value, d) {
            var conditionalFormats = field.ConditionalFormatting;
            var conditionTarget = td;
            for (var cf = 0; cf < conditionalFormats.length; cf++) {
                var conditionalFormat = conditionalFormats[cf];
                var displayText = value == "" || value == null ? NaN : value;

                if (conditionalFormat.TableField != null && conditionalFormat.TableField != "--") {
                    var conditionalTableFieldName = conditionalFormat.TableField;

                    displayText = d[conditionalTableFieldName] == null ? NaN : d[conditionalTableFieldName];
                    if (!isNaN(displayText)) conditionTarget = tr;
                }

                if (conditionalFormat.TargetProperty != null && conditionalFormat.TargetProperty != "--") {
                    var conditionalTargetName = conditionalFormat.TargetProperty;

                    if (d[conditionalTargetName] != null) conditionalFormat.FormatValue = d[conditionalTargetName].toString();
                }
                var expression = chartUtils.buildFormatExpression(conditionalFormat, displayText);
                try {
                    if (eval(expression)) {
                        applyStyles(conditionalFormat.FormatOption, conditionTarget);
                        break;
                    }
                } catch (ex) {
                    //Ignore exception & continue to next cell.
                }
            }
        }

        function applyStyles(formatOptions, td) {
            if (formatOptions != null && formatOptions.length > 0) {
                for (var fo = 0; fo < formatOptions.length; fo++) {
                    var formatOption = formatOptions[fo];
                    td.style.backgroundColor = formatOption.Fill;
                    td.style.borderColor = formatOption.BorderColor;
                    td.style.color = formatOption.ForegroundColor;
                }
            }
        }

        function isTemporalField(fieldName) {
            if (fieldName == null) return;
            fieldName = fieldName.toLowerCase();
            return fieldName.indexOf('hour') >= 0 || fieldName.indexOf('day') >= 0 || fieldName.indexOf('date') >= 0 || fieldName.indexOf('year') >= 0 || fieldName.indexOf('quarter') >= 0 || fieldName.indexOf('month') >= 0;
        }
    };

    var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
        // Get widget specific widgetConfig
        var widgetConfig = pnlChartConfigBuilder.configBuilder(cloneDeep(configObj));
        renderWidget(widgetConfig);
    };
    return {
        renderWidget: renderWidget,
        initiateWidgetRendering: initiateWidgetRendering
    };
};

export default pnlChart();